
document.addEventListener("DOMContentLoaded", function() {


    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    window.gtag = gtag;


    gtag('consent', 'default', {
        'ad_storage': 'denied',
        'ad_user_data': 'denied',
        'ad_personalization': 'denied',
        'analytics_storage': 'denied',
        'functionality_storage': 'granted',
        'personalization_storage': 'granted',
        'security_storage': 'granted'
    });

    let analyticsLoaded = false;

    function loadAnalytics() {
        if (analyticsLoaded) {
            return;
        }

        analyticsLoaded = true;

        (function(w,d,s,l,i){
            w[l]=w[l]||[];
            w[l].push({'gtm.start': new Date().getTime(), event:'gtm.js'});
            var f=d.getElementsByTagName(s)[0],
                j=d.createElement(s),
                dl=l!='dataLayer'?'&l='+l:'';
            j.async=true;
            j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
            f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-W987QL2');

        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-HGHLX29BGT';
        gtagScript.onload = function() {
            gtag('js', new Date());
            gtag('config', 'G-HGHLX29BGT', {
                'anonymize_ip': true,
                'cookie_flags': 'SameSite=None;Secure'
            });
        };
        document.head.appendChild(gtagScript);
    }

    cookieconsent.run({
        notice_banner_type: "simple",
        consent_type: "express",
        palette: "light",
        language: "pl",
        page_load_consent_levels: ["functionality", "tracking", "targeting"],
        notice_banner_reject_button_hide: false,
        preferences_center_close_button_hide: false,
        page_refresh_confirmation_buttons: false,
        website_name: "globaltransfer.pl",

        callbacks: {
            scripts_specific_loaded: (level) => {


                if (level === 'tracking' || level === 'targeting') {
                    setTimeout(function() {
                        loadAnalytics();


                        setTimeout(function() {
                            switch (level) {
                                case "tracking":
                                    gtag("consent", "update", {
                                        analytics_storage: "granted"
                                    });
                                    console.log('✅ Analytics storage: granted');
                                    break;
                                case "targeting":
                                    gtag("consent", "update", {
                                        ad_storage: "granted",
                                        ad_user_data: "granted",
                                        ad_personalization: "granted"
                                    });
                                    console.log('✅ Ad storage: granted');
                                    break;
                            }
                        }, 1000);
                    }, 100);
                }


                if (level === "functionality") {
                    setTimeout(function() {
                        gtag("consent", "update", {
                            ad_personalization: "granted"
                        });
                    }, 500);
                }
            }
        },
        callbacks_force: true
    });


    if (document.cookie.includes('cookie_consent_user_accepted=true') ||
        document.cookie.includes('cookie_consent_level=tracking') ||
        document.cookie.includes('cookie_consent_level=targeting')) {
        setTimeout(loadAnalytics, 500);

        setTimeout(function() {
            gtag("consent", "update", {
                analytics_storage: "granted",
                ad_storage: "granted",
                ad_user_data: "granted",
                ad_personalization: "granted"
            });
        }, 1500);
    }
});